import $ from 'jquery';
import '../../../../node_modules/scrolltofixed/jquery-scrolltofixed.js';

var headerHeight = $('#header').outerHeight();
function scrolltofixed() {
  $('.jsFixed').trigger('detach.ScrollToFixed');
  if (window.innerWidth > 767) {
    $('.jsFixed').scrollToFixed({
      limit: function() {
        var limit = $('.contactSection').offset().top - $('.jsFixed').outerHeight(true) - 10;
        return limit;
      },
      preFixed: function() {
        $(this).addClass('rmRadius');
      },
      unfixed: function() {
        $(this).removeClass('rmRadius');
      },
      marginTop: headerHeight,
      zIndex: 10,
    });
  }
}

function scrolltofixedSearchBox() {
  $('.jsFixedSearch').trigger('detach.ScrollToFixed');
  $('.jsFixedSearch').scrollToFixed({
    limit: function() {
      var limit = $('.consultationSection').offset().top - $('.jsFixedSearch').outerHeight(true) - 20;
      return limit;
    },
    preFixed: function() {
      $(this).addClass('reStyle');
    },
    preUnfixed: function() {
      $(this).removeClass('reStyle');
    },
    marginTop: headerHeight,
    zIndex: 10,
  });
}

function scrolltofixedSidebar() {
  $('.jsFixed01').scrollToFixed({
    limit: function() {
      if (window.innerWidth >= 768) {
        let mainPosition = $('main').offset().top,
          mainHeight = $('main').height(),
          sideHeight = $('.jsFixed01').height();
        var limit = mainPosition + mainHeight - sideHeight;
        return limit;
      }
    },
    marginTop: function() {
      let margin = $('#header').outerHeight(true);
      if (window.innerWidth >= 768) {
        margin += 10;
      }
      return margin;
    },
    zIndex: 9,
    spacerClass: 'spacerSidebar',
  });
}

function checkHeightSidebar() {
  var hSide = $('.jsFixed01').height(),
    hMain = $('main').height();
  if (hMain > hSide) {
    return true;
  }
  return false;
}

window.addEventListener('load', function(e) {
  headerHeight = $('#header').outerHeight();
  scrolltofixed();
  scrolltofixedSearchBox();

  if (window.innerWidth >= 768) {
    if (checkHeightSidebar()) {
      scrolltofixedSidebar();
    }
  } else {
    scrolltofixedSidebar();
  }
});

window.addEventListener('resize', function() {
  scrolltofixed();
  scrolltofixedSearchBox();

  var isExisted = $.isScrollToFixed('.jsFixed01');

  if (window.innerWidth >= 768) {
    if (!checkHeightSidebar() && isExisted) {
      $('.jsFixed01').trigger('detach.ScrollToFixed');
    }
  } else {
    if (!isExisted) {
      scrolltofixedSidebar();
    }
  }
});